module.exports = __webpack_public_path__ + "img/reechlogo.0fc0797d.png";